export const CORPORATE_EVENTS_HOSTNAME = 'corporateevents.luxuryescapes.com'

export function isCorporateEventsHostname(hostname?: string): boolean {
  return hostname?.toLowerCase() === CORPORATE_EVENTS_HOSTNAME
}

export function getCorporateEventBasePath(eventId: string, regionCode: string, hostname?: string): string {
  if (isCorporateEventsHostname(hostname)) {
    return `/${eventId}`
  }

  return `/${regionCode}/corporate-events/${eventId}`
}
